export enum AppRoutes {
  LOGIN = "/login",
  HOME = "/",
  ONBOARDING = "/onboarding",
  ROLES = "/roles",
  CREATE_ROLE = "/roles/create",
  UPDATE_ROLE = "/roles/update/:id",
  CONTACT = "/contacto",
  USERS = "/usuarios",
  ACCOUNTS = "/cuentas",
  ACCOUNTS_DETAIL = "/cuentas/:id",
  PERSONS = "/personas",
  PERSON_DETAIL = "/personas/:id",
  PERSON_ASSOCIATE_ACCOUNT = "/personas/:id/asociar-cuenta",
  PERSON_CREATE = "/personas/agregar",
  PERSON_UPDATE = "/personas/:id/editar",
  CBU = "/cbu",
  USER_ROLES = "/asignacion-roles",
  USER_ROLE_CREATION = "/asignacion-roles/agregar",
  USER_ROLE_EDIT = "/asignacion-roles/:id",

  //Solicitudes
  CASH_REQUESTS = "/solicitudes/efectivo",
  CASH_REQUEST_DETAIL = "/solicitudes/efectivo/:id",
  CASH_REQUEST_CREATION = "/solicitudes/efectivo/agregar",

  CHECK_REQUESTS = "/solicitudes/cheque",
  CHECK_REQUEST_DETAIL = "/solicitudes/cheque/:id",
  CHECK_REQUEST_CREATION = "/solicitudes/cheque/agregar",

  TRANSFER_REQUESTS = "/solicitudes/transferencia",
  TRANSFER_REQUEST_DETAIL = "/solicitudes/transferencia/:id",
  TRANSFER_REQUEST_CREATION = "/solicitudes/transferencia/agregar",

  EXTERNAL_TRANSFER_REQUESTS = "/transferencias-externas",
  EXTERNAL_TRANSFER_REQUEST_DETAIL = "/transferencias-externas/:id",

  SCHEDULED_TRANSFER_REQUESTS = "/transferencias-programadas",
  SCHEDULED_TRANSFER_DETAIL = "/transferencias-programadas/:id",

  BACKUP_CHECKS = "/solicitudes/cheques-respaldo",
  BACKUP_CHECKS_DETAIL = "/solicitudes/cheques-respaldo/:id",
  
  //Configuración

  PRICE_BOARD = "/pizarra",
  PRICE_BOARD_ADD = "/pizarra/agregar",

  TAXES = "/impuestos",

  REQUEST_POLICIES = "/politicas",
  REQUEST_POLICIES_ADD = "/politicas/agregar",
  REQUEST_POLICIES_EDIT = "/politicas/editar/:id",

  MOTIVES = "/motivos",
  MOTIVE_ADD = "/motivos/agregar",
  MOTIVE_EDIT = "/motivos/editar/:id",

  RELATION_FIELDS = "/campos-relaciones-familiares",
  HOBBIE_ADD = "/campos-relaciones-familiares/hobbie/agregar",
  HOBBIE_EDIT = "/campos-relaciones-familiares/hobbie/:id",
  PROFESSION_ADD = "/campos-relaciones-familiares/profesion/agregar",
  PROFESSION_EDIT = "/campos-relaciones-familiares/profesion/:id",

  FINANCIAL_MOVEMENTS_DESC = "/descripcion-movimientos-financieros",
  FINANCIAL_MOVEMENTS_DESC_ADD = "/descripcion-movimientos-financieros/agregar",
  FINANCIAL_MOVEMENTS_DESC_EDIT = "/descripcion-movimientos-financieros/editar/:id",

  APP_MAINTENANCE = "/gestion-mantenimiento-mobile",

  PRODUCTS = "/productos",
  PRODUCTS_EDIT = "/productos/:id",
  PRODUCTS_CREATION = "/productos/agregar",

  TRUCKS = "/camiones",
  TRUCKS_EDIT = "/camiones/:id",
  TRUCKS_CREATION = "/camiones/agregar",

  DRIVERS = "/fleteros",
  DRIVER_EDIT = "/fleteros/:id",
  DRIVER_CREATION = "/fleteros/agregar",

  LOGISTIC = "/logistica",

  //Solicitudes granarias
  SELL_ORDERS = "/solicitudes-granarias/ordenes-venta",
  SELL_ORDER_DETAIL = "/solicitudes-granarias/ordenes-venta/:id",
  SELL_ORDER_CREATION = "/solicitudes-granarias/ordenes-venta/agregar",

  GRAIN_DELIVERY_PAYMENTS = "/solicitudes-granarias/contra-entrega",
  GRAIN_DELIVERY_DETAIL = "/solicitudes-granarias/contra-entrega/:id",
  GRAIN_DELIVERY_CREATION = "/solicitudes-granarias/contra-entrega/agregar",

  GRAIN_FUTURE_CONTRACTS = "/solicitudes-granarias/contratos-futuros",
  GRAIN_FUTURE_CONTRACTS_DETAIL = "/solicitudes-granarias/contratos-futuros/:id",
  GRAIN_FUTURE_CONTRACTS_CREATION = "/solicitudes-granarias/contratos-futuros/agregar",

  SLOT_REQUESTS = "/solicitudes-granarias/cupos",
  SLOT_REQUEST_DETAIL = "/solicitudes-granarias/cupos/:id",
  SLOT_REQUEST_CREATION = "/solicitudes-granarias/cupos/agregar",
  //Solicitudes insumos

  FERT_SLOTS_REQ = "/solicitudes-insumos/fertilizantes",
  FERT_SLOTS_REQ_DETAIL = "/solicitudes-insumos/fertilizantes/:id",
  FERT_SLOTS_REQ_ORDER_CREATION = "/solicitudes-insumos/fertilizantes/:id/crear-pedidos",
  FERT_SLOTS_REQ_ORDER_DETAIL = "/solicitudes-insumos/fertilizantes/:id/editar-pedidos",
  FERT_SLOTS_REQ_CREATION = "/solicitudes-insumos/fertilizantes/agregar",

  FUEL_SLOTS_REQ = "/solicitudes-insumos/combustible",
  FUEL_SLOTS_REQ_DETAIL = "/solicitudes-insumos/combustible/:id",
  FUEL_SLOTS_REQ_ORDER_CREATION = "/solicitudes-insumos/combustible/:id/crear-pedidos",
  FUEL_SLOTS_REQ_ORDER_DETAIL = "/solicitudes-insumos/combustible/:id/editar-pedidos",
  FUEL_SLOTS_REQ_CREATION = "/solicitudes-insumos/combustible/agregar",

  PURCHASE_ORDER_INTENT = "/intencion-compra",
  PURCHASE_ORDER_INTENT_DETAIL = "/intencion-compra/:id",

  //Onboarding Jurídico
  LEGAL_ONBOARDING = "/onboarding-juridico",
  LEGAL_ONBOARDING_DETAIL = "/onboarding-juridico/:id",

  //Maestro de tecnicos
  TECHNICIANS = "/tecnicos",
  TECHNICIAN_CREATION = "/tecnicos/agregar",
  TECHNICIAN_DETAIL = "/tecnicos/:id",
  
  //Tipos de notificacion
  NOTIFICATIONS = "/notificaciones",
  NOTIFICATION_DETAIL = "/notificaciones/:id",

  //Producción ATA y RsaTyG

  FIELD_VISIT = "/visita-campo",
  FIELD_VISIT_DETAIL = "/visita-campo/:id",
  FIELD_VISIT_CREATION = "/visita-campo/agregar",

  PRODUCT_PLANIFICATION = "/planificacion-productiva",
  PRODUCT_PLANIFICATION_DETAIL = "/planificacion-productiva/:id",
  PRODUCT_PLANIFICATION_CREATION = "/planificacion-productiva/agregar",
  
  SAMPLING_REQUESTS = "/solicitudes-muestreo",
  SAMPLING_REQUEST_DETAIL = "/solicitudes-muestreo/:id",
  SAMPLING_REQUEST_CREATION = "/solicitudes-muestreo/agregar",

  FLIGHT_REQUESTS = "/solicitudes-vuelo",
  FLIGHT_REQUEST_DETAIL = "/solicitudes-vuelo/:id",
  FLIGHT_REQUEST_CREATION = "/solicitudes-vuelo/agregar",

  GROSS_MARGIN_REQUESTS = "/margenes-personalizados",
  GROSS_MARGIN_REQUESTS_DETAIL = "/margenes-personalizados/:id",


  //Maestros Producción

  PRODUCTION_GRAINS = "/granos-productivos",
  PRODUCTION_GRAINS_DETAIL = "/granos-productivos/:id",
  PRODUCTION_GRAINS_CREATION = "/granos-productivos/agregar",

  PRODUCTION_ZONES = "/zonas-productivas",
  PRODUCTION_ZONES_DETAIL = "/zonas-productivas/:id",
  PRODUCTION_ZONES_CREATION = "/zonas-productivas/agregar",
  
  ZONAL_GROSS_MARGINS = "/margen-bruto-zonal",
  ZONAL_GROSS_MARGINS_DETAIL = "/margen-bruto-zonal/:id",
  ZONAL_GROSS_MARGINS_CREATION = "/margen-bruto-zonal/agregar",

  ESTABLISHMENTS_MAIN_PAGE = "/establecimientos",
  ESTABLISHMENT_FIELD_DETAIL = "/establecimientos/:id",

  ESTABLISMENT_FIELD_REQUESTS = "/solicitudes-establecimientos",
  ESTABLISHMENT_FIELD_REQUEST_DETAIL = "/solicitudes-establecimientos/:id",
  //No permission
  NO_PERMISSION = "/no-permission",
}
